// extracted by mini-css-extract-plugin
export default {"label":"CompletenessIndicator_label__h2HyM"};